export const establishmentFormId = 'establishmentInformation';
export const userCreationFormId= 'itaUserCreationForm';
export const removeEstablishmentFormId = 'establishmentRemoval';
export const itaTermsAndConditions = 'itaTermsAndConditions';
export const ombMessage = 'ombMessage';
export const ombMessage2 = 'ombMessage2';
export const userCreationEmailValidationTitle = "Confirm Account Creation";
export const itaInjurySummaryFormId = 'injurySummaryForm';
export const itaInjurySummaryFormNameAdd = 'Add 300A Summary Data';
export const itaInjurySummaryFormNameEdit = 'Edit 300A Summary Data';
export const itaCreateEstablishment = 'Create Establishment';
export const itaRemoveEstablishment = 'Remove Establishment';
export const itaEditEstablishment = 'Edit Establishment';
export const itaSubmitModal = 'Confirm Submission';
export const itaSubmitModalId = 'submitModal';
export const itaFileUpload = 'Upload 300A Data';
export const itaFileUploadId = 'FileUploadForm';
export const itaCaseDataFileUpload = 'Upload 300/301 Data';
export const itaCaseDataFileUploadId = 'CaseDataFileUploadForm';
export const oshaHomePage = 'OSHA';
export const injuryReportingPage = 'Injury Reporting';
export const itaHomePage = 'Injury Tracking Application Home';
export const itaDashboardPage = 'Establishment List';
export const itaAccountPage = 'Manage My Account';
export const establishmentViewPage = 'View Establishment';
export const submissionViewPage = "View 300A Submission";
export const itaLoginPage = 'Injury Tracking Application Login';
export const itaCreateAccount = "Create Account";
export const forgotPassword = "Forgot Password?";
export const helpRequestFormId="helpRequestForm";
export const helpRequestFormIdNoAuth="helpRequestFormNoAuth";
export const helpRequestPage="Injury Tracking Application (ITA) Help Request Form";
export const helpRequestPageConfirmation="Help Request Confirmation";
export const caseDataFormNameAdd="Add 300/301 Case Data";
export const caseDataFormNameEdit="Edit 300/301 Case Data";
export const caseDataDashboard="300/301 Case Data";
export const itaCaseDataFormId="caseDataForm";
export const bulkTransferFormId="bulkTransfer";
export const bulkTransferQueryFormId="bulkTransferQuery";
export const bulkTransferPage='Bulk Transfer Establishments';
export const establishmentTransferForm='transferEstablishmentForm';



/** WEBPACK FOOTER **
 ** ./src/constants/formNameConstants.js
 **/